const state = { all: {} };
import { apiService } from "@/_services";
import { store } from "@/_store";

const actions = {
  async getAll({ commit }) {
    let params = {
      method: "GET",
      endpoint: "get_user_routes",
      content_type: "application/json",
      query_params: {
        format: "json",
        role: store.state.user.all.items.platform_role
      }
    };
    commit("getAllRequest");
    await apiService
      .getAll(params)
      .then(data => {
        // debugger;
        commit("getAllSuccess", data);
      })
      .catch(error => {
        console.log(error);
        commit("getAllFailure", error);
      });
  },
  logout({ commit }) {
    commit("logout");
  }
};

const mutations = {
  getAllRequest(state) {
    state.all = { loading: true };
  },
  getAllSuccess(state, user_routes) {
    state.all = { items: user_routes };
  },
  getAllFailure(state, error) {
    state.all = { error };
  },
  logout(state) {
    state.all = null;
  }
};

export const user_routes = {
  namespaced: true,
  state,
  actions,
  mutations
};
